import { KMutableProperty11e8g1gb0ecb9j as KMutableProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import {
  get_pageNavigator1inl9j7ja0vlf as get_pageNavigator,
  set_pageNavigator2t8ucpwsozusv as set_pageNavigator,
} from '../navigation/Navigator.mjs';
import { Companion_getInstance2eccs74uj90kl as Companion_getInstance } from '../models/Rect.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from './ViewWriter.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var navigator$delegate;
function set_safeInsets(_this__u8e3s4, _set____db54di) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_safeInsets_$ref_ujbsw9_0();
  return safeInsets$delegate.qam(_this__u8e3s4, getPropertyCallableRef('safeInsets', 1, tmp, tmp_0, _set_safeInsets_$ref_eyot1f_0()), _set____db54di);
}
function get_safeInsets(_this__u8e3s4) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_safeInsets_$ref_ujbsw9();
  return safeInsets$delegate.oam(_this__u8e3s4, getPropertyCallableRef('safeInsets', 1, tmp, tmp_0, _set_safeInsets_$ref_eyot1f()));
}
var safeInsets$delegate;
function set_popoverParent(_this__u8e3s4, _set____db54di) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_popoverParent_$ref_xfiq5t_0();
  return popoverParent$delegate.qam(_this__u8e3s4, getPropertyCallableRef('popoverParent', 1, tmp, tmp_0, _set_popoverParent_$ref_fvsfiz_0()), _set____db54di);
}
function get_popoverParent(_this__u8e3s4) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_popoverParent_$ref_xfiq5t();
  return popoverParent$delegate.oam(_this__u8e3s4, getPropertyCallableRef('popoverParent', 1, tmp, tmp_0, _set_popoverParent_$ref_fvsfiz()));
}
var popoverParent$delegate;
function set_popoverCloser(_this__u8e3s4, _set____db54di) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_popoverCloser_$ref_xuz76p_0();
  return popoverCloser$delegate.qam(_this__u8e3s4, getPropertyCallableRef('popoverCloser', 1, tmp, tmp_0, _set_popoverCloser_$ref_fgbyi3_0()), _set____db54di);
}
function get_popoverCloser(_this__u8e3s4) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_popoverCloser_$ref_xuz76p();
  return popoverCloser$delegate.oam(_this__u8e3s4, getPropertyCallableRef('popoverCloser', 1, tmp, tmp_0, _set_popoverCloser_$ref_fgbyi3()));
}
var popoverCloser$delegate;
function set_popoverKeepOpen(_this__u8e3s4, _set____db54di) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_popoverKeepOpen_$ref_o2wcvo_0();
  return popoverKeepOpen$delegate.qam(_this__u8e3s4, getPropertyCallableRef('popoverKeepOpen', 1, tmp, tmp_0, _set_popoverKeepOpen_$ref_xnhg74_0()), _set____db54di);
}
function get_popoverKeepOpen(_this__u8e3s4) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_popoverKeepOpen_$ref_o2wcvo();
  return popoverKeepOpen$delegate.oam(_this__u8e3s4, getPropertyCallableRef('popoverKeepOpen', 1, tmp, tmp_0, _set_popoverKeepOpen_$ref_xnhg74()));
}
var popoverKeepOpen$delegate;
function rContextAddon(init) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  return new (rContextAddon$1())(init);
}
function rContextAddonInit() {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  return new (rContextAddonInit$1())();
}
function rContextAddonGenerate(init) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  return new (rContextAddonGenerate$1())(init);
}
function closePopovers(_this__u8e3s4) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp0_safe_receiver = get_popoverCloser(_this__u8e3s4);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver();
  set_popoverCloser(_this__u8e3s4, null);
  var tmp1_safe_receiver = get_popoverParent(_this__u8e3s4);
  if (tmp1_safe_receiver == null)
    null;
  else {
    closePopovers(tmp1_safe_receiver);
  }
}
function popoverWriter(_this__u8e3s4, overlay, popoverRoot, close) {
  overlay = overlay === VOID ? _this__u8e3s4 : overlay;
  popoverRoot = popoverRoot === VOID ? false : popoverRoot;
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp0_safe_receiver = get_popoverCloser(_this__u8e3s4);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver();
  set_popoverCloser(_this__u8e3s4, close);
  var writer = new (popoverWriter$writer$1())(_this__u8e3s4, overlay);
  // Inline function 'kotlin.takeIf' call
  var tmp;
  if (!popoverRoot) {
    tmp = _this__u8e3s4;
  } else {
    tmp = null;
  }
  var tmp$ret$1 = tmp;
  set_popoverParent(writer, tmp$ret$1);
  set_popoverCloser(writer, null);
  return writer;
}
function keepPopoverOpen(_this__u8e3s4, lifecycle) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var _unary__edvuaz = get_popoverKeepOpen(_this__u8e3s4);
  set_popoverKeepOpen(_this__u8e3s4, _unary__edvuaz + 1 | 0);
  onRemove(lifecycle, () => {
    var _unary__edvuaz = get_popoverKeepOpen(_this__u8e3s4);
    set_popoverKeepOpen(_this__u8e3s4, _unary__edvuaz - 1 | 0);
    return Unit_instance;
  });
}
function closeSiblingPopovers(_this__u8e3s4) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp0_safe_receiver = get_popoverCloser(_this__u8e3s4);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver();
  set_popoverCloser(_this__u8e3s4, null);
}
function _get_pageNavigator_$ref_twffzs() {
  return (p0) => get_pageNavigator(p0);
}
function _set_pageNavigator_$ref_jevpp0() {
  return (p0, p1) => {
    set_pageNavigator(p0, p1);
    return Unit_instance;
  };
}
function safeInsets$delegate$lambda($this$rContextAddonGenerate) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  return new (Constant())(_Constant___init__impl__v45mub(Companion_getInstance().zcz_1));
}
function _get_safeInsets_$ref_ujbsw9() {
  return (p0) => get_safeInsets(p0);
}
function _set_safeInsets_$ref_eyot1f() {
  return (p0, p1) => {
    set_safeInsets(p0, p1);
    return Unit_instance;
  };
}
function _get_safeInsets_$ref_ujbsw9_0() {
  return (p0) => get_safeInsets(p0);
}
function _set_safeInsets_$ref_eyot1f_0() {
  return (p0, p1) => {
    set_safeInsets(p0, p1);
    return Unit_instance;
  };
}
function popoverParent$delegate$lambda($this$rContextAddonGenerate) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  return null;
}
function _get_popoverParent_$ref_xfiq5t() {
  return (p0) => get_popoverParent(p0);
}
function _set_popoverParent_$ref_fvsfiz() {
  return (p0, p1) => {
    set_popoverParent(p0, p1);
    return Unit_instance;
  };
}
function _get_popoverParent_$ref_xfiq5t_0() {
  return (p0) => get_popoverParent(p0);
}
function _set_popoverParent_$ref_fvsfiz_0() {
  return (p0, p1) => {
    set_popoverParent(p0, p1);
    return Unit_instance;
  };
}
function popoverCloser$delegate$lambda($this$rContextAddonGenerate) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  return null;
}
function _get_popoverCloser_$ref_xuz76p() {
  return (p0) => get_popoverCloser(p0);
}
function _set_popoverCloser_$ref_fgbyi3() {
  return (p0, p1) => {
    set_popoverCloser(p0, p1);
    return Unit_instance;
  };
}
function _get_popoverCloser_$ref_xuz76p_0() {
  return (p0) => get_popoverCloser(p0);
}
function _set_popoverCloser_$ref_fgbyi3_0() {
  return (p0, p1) => {
    set_popoverCloser(p0, p1);
    return Unit_instance;
  };
}
function popoverKeepOpen$delegate$lambda($this$rContextAddonGenerate) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  return 0;
}
function _get_popoverKeepOpen_$ref_o2wcvo() {
  return (p0) => get_popoverKeepOpen(p0);
}
function _set_popoverKeepOpen_$ref_xnhg74() {
  return (p0, p1) => {
    set_popoverKeepOpen(p0, p1);
    return Unit_instance;
  };
}
function _get_popoverKeepOpen_$ref_o2wcvo_0() {
  return (p0) => get_popoverKeepOpen(p0);
}
function _set_popoverKeepOpen_$ref_xnhg74_0() {
  return (p0, p1) => {
    set_popoverKeepOpen(p0, p1);
    return Unit_instance;
  };
}
var rContextAddon$1Class;
function rContextAddon$1() {
  if (rContextAddon$1Class === VOID) {
    class $ {
      constructor($init) {
        this.cd9_1 = $init;
      }
      dd9(thisRef, property) {
        var tmp0 = thisRef.pc().sb3_1;
        // Inline function 'kotlin.collections.getOrPut' call
        var key = property.callableName;
        var value = tmp0.p3(key);
        var tmp;
        if (value == null) {
          var answer = this.cd9_1;
          tmp0.s3(key, answer);
          tmp = answer;
        } else {
          tmp = value;
        }
        var tmp_0 = tmp;
        return (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
      }
      oam(thisRef, property) {
        return this.dd9(thisRef instanceof ViewWriter() ? thisRef : THROW_CCE(), property);
      }
      ed9(thisRef, property, value) {
        var tmp0 = thisRef.pc().sb3_1;
        // Inline function 'kotlin.collections.set' call
        var key = property.callableName;
        tmp0.s3(key, value);
      }
      qam(thisRef, property, value) {
        var tmp = thisRef instanceof ViewWriter() ? thisRef : THROW_CCE();
        return this.ed9(tmp, property, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($);
    rContextAddon$1Class = $;
  }
  return rContextAddon$1Class;
}
var rContextAddonInit$1Class;
function rContextAddonInit$1() {
  if (rContextAddonInit$1Class === VOID) {
    class $ {
      dd9(thisRef, property) {
        var tmp0 = thisRef.pc().sb3_1;
        // Inline function 'kotlin.collections.getOrPut' call
        var key = property.callableName;
        var value = tmp0.p3(key);
        var tmp;
        if (value == null) {
          throw IllegalStateException().o4(property.callableName + ' has not been initialized. ' + thisRef.pc().toString());
        } else {
          tmp = value;
        }
        var tmp_0 = tmp;
        return (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
      }
      oam(thisRef, property) {
        return this.dd9(thisRef instanceof ViewWriter() ? thisRef : THROW_CCE(), property);
      }
      ed9(thisRef, property, value) {
        var tmp0 = thisRef.pc().sb3_1;
        // Inline function 'kotlin.collections.set' call
        var key = property.callableName;
        tmp0.s3(key, value);
      }
      qam(thisRef, property, value) {
        var tmp = thisRef instanceof ViewWriter() ? thisRef : THROW_CCE();
        return this.ed9(tmp, property, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($);
    rContextAddonInit$1Class = $;
  }
  return rContextAddonInit$1Class;
}
var rContextAddonGenerate$1Class;
function rContextAddonGenerate$1() {
  if (rContextAddonGenerate$1Class === VOID) {
    class $ {
      constructor($init) {
        this.fd9_1 = $init;
      }
      dd9(thisRef, property) {
        var tmp0 = thisRef.pc().sb3_1;
        // Inline function 'kotlin.collections.getOrPut' call
        var key = property.callableName;
        var value = tmp0.p3(key);
        var tmp;
        if (value == null) {
          var answer = this.fd9_1(thisRef);
          tmp0.s3(key, answer);
          tmp = answer;
        } else {
          tmp = value;
        }
        var tmp_0 = tmp;
        return (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
      }
      oam(thisRef, property) {
        return this.dd9(thisRef instanceof ViewWriter() ? thisRef : THROW_CCE(), property);
      }
      ed9(thisRef, property, value) {
        var tmp0 = thisRef.pc().sb3_1;
        // Inline function 'kotlin.collections.set' call
        var key = property.callableName;
        tmp0.s3(key, value);
      }
      qam(thisRef, property, value) {
        var tmp = thisRef instanceof ViewWriter() ? thisRef : THROW_CCE();
        return this.ed9(tmp, property, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($);
    rContextAddonGenerate$1Class = $;
  }
  return rContextAddonGenerate$1Class;
}
var popoverWriter$writer$1Class;
function popoverWriter$writer$1() {
  if (popoverWriter$writer$1Class === VOID) {
    class $ extends ViewWriter() {
      constructor($this_popoverWriter, $overlay, $box) {
        if ($box === VOID)
          $box = {};
        $box.kd9_1 = $overlay;
        super($box);
        this.id9_1 = $this_popoverWriter;
        this.jd9_1 = $this_popoverWriter.pc().rb3();
      }
      pc() {
        return this.jd9_1;
      }
      pba(view) {
        return this.kd9_1.pba(view);
      }
      rba(view) {
        return this.kd9_1.rba(view);
      }
      ea2() {
        return this.id9_1.ea2();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [ViewWriter(), CoroutineScope()]);
    popoverWriter$writer$1Class = $;
  }
  return popoverWriter$writer$1Class;
}
var properties_initialized_ViewContextExtensions_kt_vqh4wi;
function _init_properties_ViewContextExtensions_kt__afzhxo() {
  if (!properties_initialized_ViewContextExtensions_kt_vqh4wi) {
    properties_initialized_ViewContextExtensions_kt_vqh4wi = true;
    var tmp = KMutableProperty1();
    var tmp_0 = _get_pageNavigator_$ref_twffzs();
    navigator$delegate = getPropertyCallableRef('pageNavigator', 1, tmp, tmp_0, _set_pageNavigator_$ref_jevpp0());
    safeInsets$delegate = rContextAddonGenerate(safeInsets$delegate$lambda);
    popoverParent$delegate = rContextAddonGenerate(popoverParent$delegate$lambda);
    popoverCloser$delegate = rContextAddonGenerate(popoverCloser$delegate$lambda);
    popoverKeepOpen$delegate = rContextAddonGenerate(popoverKeepOpen$delegate$lambda);
  }
}
//region block: exports
export {
  closePopovers as closePopovers89geeulkriez,
  closeSiblingPopovers as closeSiblingPopovers3h32tmqbne06n,
  keepPopoverOpen as keepPopoverOpen73dsmiswwblk,
  get_popoverCloser as get_popoverCloseraz5y36f5ki4,
  get_popoverKeepOpen as get_popoverKeepOpenw4wxrp4j0c27,
  popoverWriter as popoverWriter15t7cytib9867,
  rContextAddonGenerate as rContextAddonGenerate29u6cpzj8mq24,
  rContextAddonInit as rContextAddonInit1l0t8s3axt11t,
  rContextAddon as rContextAddon3rgt985u8pvgw,
  get_safeInsets as get_safeInsets20bpe8v7txtx4,
  set_safeInsets as set_safeInsets3hvkcq1e3pzpz,
};
//endregion

//# sourceMappingURL=ViewContextExtensions.mjs.map
